import { faFilter } from "@fortawesome/free-solid-svg-icons";
import Icon from "components/components/Icon/Icon";
import { IconSize } from "components/components/Icon/IconWrapper";
import { AppliedFilters } from "components/components/Iris/AuthenticatedView/IrisDetailsPage/IrisDetails/QueueInfoCard/QueueFilters/AppliedFilters";
import React, { useState } from "react";

import { QueueFiltersSelector } from "./QueueFiltersSelector";
import { StyledFilterButton } from "./style";

interface Props {
  queueTitle: string;
  appliedFilters: string[];
  onRemoveAllFiltersClick: () => void;
  fetchIrisDetails: () => void;
}

export const QueueFilters: React.FC<Props> = ({
  queueTitle,
  appliedFilters,
  onRemoveAllFiltersClick,
  fetchIrisDetails,
}) => {
  const hasAppliedFilters = appliedFilters.length > 0;

  const [isSelectorModalActive, setIsSelectorModalActive] = useState(false);

  return (
    <>
      <StyledFilterButton
        type="button"
        data-test-id="queue-filters-button"
        className={hasAppliedFilters ? "active" : ""}
        onClick={(): void => setIsSelectorModalActive(true)}
      >
        <span>{hasAppliedFilters ? "Edit" : "Add"} filters</span>
        <Icon iconName={faFilter} size={IconSize.xSmall} />
      </StyledFilterButton>

      <QueueFiltersSelector
        queueTitle={queueTitle}
        appliedFilters={appliedFilters}
        isModalActive={isSelectorModalActive}
        setIsModalActive={setIsSelectorModalActive}
        fetchIrisDetails={fetchIrisDetails}
      />

      {appliedFilters.length > 0 && (
        <AppliedFilters
          appliedFilters={appliedFilters}
          onRemoveAllFiltersClick={onRemoveAllFiltersClick}
        />
      )}
    </>
  );
};
